import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "slots", "monthLabel"]
  static values = { slug: String, serviceId: String, timezone: String, selectedDate: String }

  connect() {
    if (this.selectedDateValue) {
      this.currentMonth = new Date(this.selectedDateValue + "T00:00:00")
    } else {
      this.currentMonth = new Date()
    }
    this.renderCalendar()
  }

  previousMonth() {
    this.currentMonth.setMonth(this.currentMonth.getMonth() - 1)
    this.renderCalendar()
  }

  nextMonth() {
    this.currentMonth.setMonth(this.currentMonth.getMonth() + 1)
    this.renderCalendar()
  }

  renderCalendar() {
    const year = this.currentMonth.getFullYear()
    const month = this.currentMonth.getMonth()

    this.monthLabelTarget.textContent = new Date(year, month).toLocaleDateString("en-US", { month: "long", year: "numeric" })

    const firstDay = new Date(year, month, 1).getDay()
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    // Clear existing day cells (keep headers)
    const headers = Array.from(this.gridTarget.querySelectorAll("span:nth-child(-n+7)"))
    this.gridTarget.innerHTML = ""
    headers.forEach(h => this.gridTarget.appendChild(h))

    // Empty cells before first day
    for (let i = 0; i < firstDay; i++) {
      this.gridTarget.appendChild(this.createEmptyCell())
    }

    // Day cells
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day)
      const isPast = date < today
      const dateStr = date.toISOString().split("T")[0]
      const isSelected = dateStr === this.selectedDateValue
      this.gridTarget.appendChild(this.createDayCell(day, date, isPast, isSelected))
    }
  }

  createEmptyCell() {
    const span = document.createElement("span")
    span.className = "py-2"
    return span
  }

  createDayCell(day, date, isPast, isSelected) {
    const button = document.createElement("button")
    button.type = "button"
    button.textContent = day

    if (isPast) {
      button.className = "py-2 rounded-lg text-neutral-300 cursor-not-allowed"
      button.disabled = true
    } else if (isSelected) {
      button.className = "py-2 rounded-lg bg-primary-600 text-white font-semibold shadow-sm cursor-pointer"
      button.dataset.action = "click->booking-calendar#selectDate"
      button.dataset.date = date.toISOString().split("T")[0]
    } else {
      button.className = "py-2 rounded-lg text-neutral-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
      button.dataset.action = "click->booking-calendar#selectDate"
      button.dataset.date = date.toISOString().split("T")[0]
    }

    return button
  }

  selectDate(event) {
    const date = event.target.dataset.date
    const url = `/${this.slugValue}/book/${this.serviceIdValue}?date=${date}`
    window.Turbo.visit(url)
  }
}
